// extracted by mini-css-extract-plugin
module.exports = {"ourBrainLogoContainer":"OurBrainLogo_ourBrainLogoContainer__1lmHA"};